import { queryOptions } from "@tanstack/react-query";
import { PageParams, Paginated, ShallowCourse } from "@vixi/types";
import { api, endpoints } from "@vixi/api";

/**
 * Query options to get the count of ALL courses regardless of status.
 * Uses the getAllCourses endpoint without status filter.
 *
 * @returns Query options that return the total count of all courses (Published, In Review, Draft)
 */
export const allCoursesCountQueryOptions = () =>
  queryOptions({
    queryKey: ["allCoursesCount"],
    queryFn: async () => {
      const response = await api.get<Paginated<ShallowCourse>>(endpoints.getAllCourses, {
        params: {
          pageNumber: 1,
          pageSize: 1,
        } satisfies PageParams,
      });

      return response.data.totalCount ?? 0;
    },
  });
